
export const TABLE_COLUMNS = [
  {
    Header: "Report Name",
    accessor: "report_name",
  },
  {
    Header: "Scheduled",
    accessor: "frequency",
  },
  {
    Header: "Created By",
    accessor: "creator.name",
  },
  {
    Header: "To",
    accessor: "recipient",
  },
  {
    Header: "Created At",
    accessor: "created_at",
    Cell: ({ row, value }) => {
      return new Date(row.original.created_at)?.toLocaleDateString("en-us");
    },
  }
];
